import { Course, Genre, MenuBook, SubGenre } from '../../models';
import MenuRow from '../MenuRow';
import SubMenuGroupRowList from '../SubMenuGroupRowList';

export interface MenuRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
}

function MenuRowList({ menuBook, course, genre, subgenre }: MenuRowListProps) {
  return (
    <>
      {subgenre.menus.map((menu) => (
        <MenuRow
          key={`menu-${menuBook.id}-${genre.id}--${subgenre.id}-${menu.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
          menu={menu}
        >
          <SubMenuGroupRowList menuBook={menuBook} course={course} genre={genre} subgenre={subgenre} menu={menu} />
        </MenuRow>
      ))}
    </>
  );
}

export default MenuRowList;
